import { Route, Routes } from "react-router-dom";
import { UserProfile } from "./user-profile";
import { ProfileLayout } from "./profile-layout";

export function ProfileRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ProfileLayout />}>
        <Route index element={<UserProfile />} />

        <Route path="*" element="Profile: Page Not Found" />
      </Route>
    </Routes>
  );
}
